module.exports = __webpack_public_path__ + "img/note_icon.780df8e1.svg";